import { Form, Input, Button, Popconfirm, Table, Typography, Select, Modal, message, Switch, Tree, Space } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import React, { useState, useEffect, useRef } from 'react';

import Api from "../../../api";
import {pagingParam} from "../../../utils/defaultValue";
import storage from '../../../utils/storage'
import {ModalConfirm} from '../../../utils/tool'
import SelfTable from "../../../components/SelfTable/index"

import './index.scss'

const { confirm } = Modal;
const { TextArea } = Input;

const TenantList = ({tableHight}) => {
    const [form] = Form.useForm();
    const [addForm] = Form.useForm();

    // 列表数据
    const [listData, setListData] = useState([]);

    // 当前正在操作的数据KEY
    const [editingKey, setEditingKey] = useState({});

    // 查询数据
    const [searchData, setSearchData] = useState({
        ...pagingParam
    });
    // 分页
    const [pagination, setPagination] = useState({
        "pageIndex": 0,
        "pageSize": 0,
        "total":0
    });

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [confirmLoading, setConfirmLoading] = useState(false);

    const [menuData, setMenuData] = useState([]);

    const [checkedMenuKeys, setCheckedMenuKeys] = useState([]);

    const [tableLoading, setTableLoading] = useState(false);

    const [operationData, setOperationData] = useState({});



    useEffect(() => {
        getMenuList();
    }, []);

    useEffect(() => {
        getList();
    }, [searchData]);

    // 获取菜单列表数据
    const getMenuList = async() => {
        const res = await Api.Menu.getAllMenuListTree();
        if(res&&res.code === 0){
            let _data = res.data;
            setMenuData(_data);
        }
    }

    // 获取列表数据
    const getList = async() => {
        setTableLoading(true);
        const res = await Api.Tenant.getTenantPackageList({data:searchData});
        setTableLoading(false);
        if(res&&res.code === 0){
            let _data = res.data;
            setListData(_data.records);
            setPagination({
                "pageIndex": _data.current,
                "pageSize": _data.size,
                "total":_data.total
            });
            setEditingKey('');
        }else{
            setListData([]);
        }
    }

    // 修改
    const edit = async(record) => {
        // try{
        //     const res = await Api.Tenant.getTenantPackageDetails(record.packageId);
        //     if(res.code === 0){
                
        //     }
        // } catch (errInfo) {
        //     console.log('验证失败:', errInfo);
        // }

        setIsModalOpen(true);
        record.menuIds = record.menuIdList;
        setCheckedMenuKeys(record.menuIds);
        setEditingKey(record);
        addForm.setFieldsValue({
           ...record,
        });
    };

    // 新增
    const handleOk = async() => {
        try {
            const row = await addForm.validateFields();
            row.menuIds = checkedMenuKeys;
            setConfirmLoading(true);
            
            if(editingKey){
                row.packageId = editingKey.packageId;
                const res = await Api.Tenant.updateTenantPackage({data:row});
                if(res&&res.code === 0){
                    message.success("修改成功",2,()=>{
                        setConfirmLoading(false);
                        setIsModalOpen(false);
                        setCheckedMenuKeys([]);
                        getList();
                    })
                }
            }else{
                const res = await Api.Tenant.addTenantPackage({data:row});
                if(res&&res.code === 0){
                    message.success("新增成功",2,()=>{
                        setConfirmLoading(false);
                        handleCancel();
                        getList();
                    })
                }else{setConfirmLoading(false);}
            }
        } catch (errInfo) {
            console.log('验证失败:', errInfo);
        }
    }

    // 打开新增角色权限
    const addTenant = () => {
        setConfirmLoading(false);
        setIsModalOpen(true);
    }

    //删除角色权限
    const deleteTenantModal = (record) => {
        ModalConfirm({
            title: `您确认要删除这条数据吗?`,
            onOk:async(resolve, reject)=> {
                try{
                    const res = await Api.Tenant.deleteTenantPackage(record.packageId);
                    resolve();
                    if(res && res.code === 0){
                        let newSearchData = {...searchData}
                        newSearchData.pageIndex = 1;
                        setSearchData(newSearchData);
                    }
                }catch{}
            },
        })
    }

    // 关闭新增角色权限
    const handleCancel = () => {
        setEditingKey("");
        setCheckedMenuKeys([])
        setIsModalOpen(false);
    }

    // 分页变化
    const paginationChange = (page, pageSize) => {
        let newSearchData = {...searchData}
        newSearchData.pageIndex = page;
        newSearchData.pageSize = pageSize;
        setSearchData(newSearchData);
    }

    const columns = [
        {
            title: '套餐名称',
            dataIndex: 'packageName',
            width: '',
            align:"center",
            editable: true,
        },
        
        {
            title: '备注',
            dataIndex: 'remark',
            width: '',
            align:"center",
            editable: true,
        },
        {
            title: '租户状态',
            dataIndex: 'status',
            width: '150px',
            align:"center",
            render: (_, record) => (
            <>
                <Switch
                    size="small"
                    checked={record.status == 0}
                    onChange={() => onChangeStatus(record)}
                    style={{'marginTop': '-3px',marginRight: 5}}
                />
                {record.status == 0 ? "启用" : "禁用"}
            </>
            ),
        },
        {
            title: '操作',
            width: '200px',
            align:"center",
            dataIndex: 'operation',
            render: (_, record) => {
                return(<Space>
                    <Typography.Link onClick={() => edit(record)}>
                        调整
                    </Typography.Link>
                    <Typography.Link type="danger" onClick={()=>{deleteTenantModal(record)}}>
                        删除
                    </Typography.Link>
            </Space>)
            },
        },
    ];

    const onChangeStatus = async (record) => {
        let res = await Api.Tenant.changePackageStatus({ data: {
            packageId: record.packageId,
            status: record.status == 0 ? 1 : 0
        } });
        if (res && res.data) {
            let newSearchData = {...searchData}
            newSearchData.pageIndex = 1;
            setSearchData(newSearchData);
            message.success("操作成功");
        }
    };

    const onCheck = (checkedKeys,e) => {
        let list = [];

        function treeLoad(lists){
            lists.map(item=>{
                list.push(item.id);
                if(item.children && item.children.length > 0){
                    treeLoad(item.children)
                }
            })
        }

        if(e.checked){
            let _node = [e.node]
            treeLoad(_node);

            let _checkedMenuKeys = Array.from(new Set([...checkedMenuKeys,...list]))
            
            setCheckedMenuKeys(_checkedMenuKeys)
        }else{
            let _node = [e.node]
            treeLoad(_node);

            let _checkedMenuKeys = checkedMenuKeys.filter((item) => {
                return !list.includes(item)
            });
            setCheckedMenuKeys(_checkedMenuKeys)
        }
    };

    const tableChanges = (pagination, filters) => {
        let newSearchData = {...searchData}
        newSearchData.pageIndex = pagination.current;
        newSearchData.pageSize = pagination.pageSize;
        setSearchData(newSearchData);
    }

    const searchChange = (value, type) => {
        let newOperationData = {...operationData};
        newOperationData[type] = value;
        setOperationData(newOperationData)
    }

    const onResetting = () => {
        setOperationData({});
        setSearchData({
            ...pagingParam,
        })
    }

    const onSearch = () => {
        let newSearchData = {
            ...searchData,
            ...operationData,
            pageNum:1
        }
        setSearchData(newSearchData);
    }

    return (
        <div className="tenantListFrame">
            <div className="title">租户套餐管理</div>
            <div className="operation">
                <div className="operationLeft">
                    <div className="operationItem">
                        <span className="inputTitle">套餐名称：</span>
                        <Input 
                            placeholder="输入套餐名称" 
                            value={operationData.packageName} 
                            onChange={(e)=>{
                                searchChange(e.target.value,"packageName")
                            }}
                            allowClear={true}
                        />
                    </div>
                    <Space size={"middle"}>
                        <Button type="primary" onClick={onSearch}>搜索</Button>
                        <Button onClick={onResetting}>重置</Button>
                    </Space>
                </div>

                <Space size={"large"}>
                    <Button type="primary" onClick={addTenant}>新增租户套餐</Button>
                </Space>
            </div>
            <div className="table">
                <Form form={form} component={false}>
                    <SelfTable
                        dataSource={listData}
                        columns={columns}
                        pagination={{
                            ...pagination,
                            onChange: paginationChange,
                        }}
                        loading={tableLoading}
                    />
                </Form>
            </div>

            <Modal
                title="新增租户"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                maskClosable={false}
                destroyOnClose={true}
                confirmLoading={confirmLoading}
                // forceRender
            >
                <Form
                    form={addForm}
                    component={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 14 }}
                    preserve={false}
                >
                    <Form.Item
                        key={'packageName'}
                        label={'套餐名称'}
                        name={'packageName'}
                        rules={[{ required: true, message: `请输入套餐名称!` }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        key={'remark'}
                        label={'备注'}
                        name={'remark'}
                    >
                        <TextArea />
                    </Form.Item>

                    <Form.Item
                        key={'menuIds'}
                        label={'菜单权限'}
                        name={'menuIds'}
                    >
                        <div className="treeBox">
                            <Tree
                                checkable
                                checkedKeys={checkedMenuKeys}
                                defaultCheckedKeys={checkedMenuKeys}
                                onCheck={onCheck}
                                treeData={menuData}
                                checkStrictly={true}
                                fieldNames={{
                                    title: 'name',
                                    key:'id'
                                }}
                            />
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};
export default TenantList;
